import { apiClient } from '@/api/client';

export function useVehicleImageUrl(vin: string | null | undefined): string | null {
  if (!vin || vin === 'NO VIN' || vin.startsWith('System.') || vin.length < 10) {
    return null;
  }
  return apiClient.getVehicleImageUrl(vin);
}
